import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedApiDocs,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPages } from '../../components/PublishedPages/PublishedPages';

export const PublishedApiDocs = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Api Docs'
      }
    ]);
  }, []);
  return <PublishedPages nameField="version" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPages: state.getIn([NS, 'publishedApiDocs']),
  pending: state.getIn([NS, 'pending', 'publishedApiDocs']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPages: serviceHandle =>
    dispatch(getPublishedApiDocs(serviceHandle)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedApiDocs);
